export default __webpack_public_path__ + "img/catIcon15.22a8d1fd.svg";